import React, {useContext} from "react";
import {Typography, Space} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";

// forms
import EditPhoneForm from "../../forms/editPhone";
// core
import {LayoutContext} from "../../../core/Contexts";

export default React.memo(
    observer(function EditPhoneModal({phone}: Props) {
        const contextLayout = useContext(LayoutContext);
        const {t} = useTranslation();

        return (
            <Typography as="div" className="bl-edit-phone-modal">
                <Space
                    size={_.gte(contextLayout?.width ?? 0, 768) ? 40 : 24}
                    direction="vertical"
                    align="center"
                >
                    <Typography as="div">
                        <Space size={8} direction="vertical" align="center">
                            <Typography
                                size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
                                level={2}
                                color="#000000"
                            >
                                {t("Сменить номер телефона")}
                            </Typography>
                            <Typography color="#000000" className="subtitle">
                                {t("Номер телефона используется для оплаты, связью с центром ")}
                                <br />
                                {t("поддержки дилеров в случае отсутствия доступа к сети интернет")}
                            </Typography>
                        </Space>
                    </Typography>
                    <EditPhoneForm phone={phone} />
                </Space>
            </Typography>
        );
    })
);

interface Props {
    phone: number;
}
